import React from 'react';
import {Dropdown as SemanticDropdown} from 'semantic-ui-react';
import classNames from 'classnames';
import {ErrorMessage} from 'formik';

import * as handlers from './handlers';
import Error from './../Error';
import {Props} from './types';

import './index.scss';

const Dropdown: React.FC<Props> = props => {
  const {hideErrorMessage, restProps} = props;

  return (
    <div
      className={classNames('a__input-dropdown', {
        disabled: props.disabled,
        white: props.color === 'white',
        sm: props.size === 'sm',
      })}
    >
      <SemanticDropdown
        placeholder={props.placeholder || '選択してください'}
        selection
        upward={false}
        options={props.options}
        disabled={props.disabled}
        value={props.field.value}
        error={
          props.form.touched[props.field.name] &&
          !!props.form.errors[props.field.name]
        }
        onChange={(e, data) =>
          props.mode === 'find'
            ? handlers.changeDateDuration(
                props.form,
                props.field,
                data.value,
                props.actions,
                props.me
              )
            : props.form.setFieldValue(`${props.field.name}`, data.value)
        }
        {...restProps}
      />
      {hideErrorMessage ? null : (
        <ErrorMessage name={props.field.name} component={Error} />
      )}
    </div>
  );
};
export default Dropdown;
